import { forwardRef } from 'react';
import styled from 'styled-components';
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
import { devices } from 'signup-constants/styles/viewports.styles';
import { DisplayMode } from '../views-components/DisplayMode';
import FormControl from '../views-components/FormControl';
import TextInput from '../views-components/TextInput';
import { useInputProps } from './useInputProps';
import { useSignupData } from './useSignupData';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { Step } from 'signup-constants/Step';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { isLeftAlignedLayout } from '../utils/isLeftAlignedLayout';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDataInput = styled.div.withConfig({
  displayName: "SignupDataInput__StyledDataInput",
  componentId: "sc-191se8y-0"
})(["min-height:6.8rem;label{font-weight:400;font-size:16px;}@media ", "{min-height:", ";", "}", " ", " ", ""], devices.desktop, props => props.isFramedCentredStep ? '6.5rem' : '7.5rem', props => isLeftAlignedLayout(props.layoutType) && props.currentStep !== Step.LandingPage && `width: 420px;`, props => props.theme.embedded && `min-height: 4.7rem;`, props => props.isFramedCentredStep && `min-height: 6.5rem;`, props => props.height && `min-height: ${props.height} !important;`);
export const SignupDataInput = /*#__PURE__*/forwardRef(({
  dataKey,
  disabled = false,
  displayMode = DisplayMode.Placeholder,
  customValidationError,
  renderExtraIcons,
  type,
  inputMode,
  autoFocus = true,
  help,
  shouldShowPlaceholder = false,
  onFocus,
  onBlur,
  shouldTrimData = false,
  height = ''
}, ref) => {
  const {
    data,
    setData
  } = useSignupData(dataKey, shouldTrimData);
  const inputProps = useInputProps(dataKey);
  const {
    layoutType
  } = useLayoutTemplate();
  const {
    currentStep
  } = useCurrentStep();
  const placeholder = shouldShowPlaceholder ? inputProps.placeholder : '';
  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();
  const renderInput = () => {
    return /*#__PURE__*/_jsx(TextInput, Object.assign({
      autoFocus: autoFocus,
      disabled: disabled,
      displayMode: displayMode,
      inputMode: inputMode,
      ref: ref,
      renderExtraIcons: renderExtraIcons,
      type: type,
      value: disabled ? '' : data,
      onBlur: onBlur,
      onChange: setData,
      onFocus: onFocus
    }, inputProps, {
      placeholder: placeholder
    }));
  };
  const maybeWrapTextInput = () => {
    return /*#__PURE__*/_jsx(FormControl, {
      customValidationError: customValidationError,
      dataKey: dataKey,
      help: help,
      children: renderInput()
    });
  };
  return /*#__PURE__*/_jsx(StyledDataInput
  // @ts-expect-error Expression produces a union type that is too complex to represent.
  , {
    className: `SignupDataInput displayMode-${displayMode}`,
    currentStep: currentStep,
    "data-data-key": dataKey,
    height: height,
    isFramedCentredStep: isFramedCentredStep,
    layoutType: layoutType,
    children: maybeWrapTextInput()
  });
});